import styled from 'styled-components';
import { colorWhite } from 'styleUtils';
export var ProductsWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1klissw-0"
})(["width:100%;margin:16px 0 0 0;"]);
export var ListWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1klissw-1"
})(["display:flex;flex-direction:column;width:100%;background-color:", ";padding:24px 16px 0 16px;&:not(:last-child){margin:0 0 8px 0;}"], colorWhite);